export default __webpack_public_path__ + "static/media/iconouno.254d9672.svg";